/**
 * @memberof module:util
 * @function isSameDestinationDischarge
 * @description True only when a rate's destination (location_to) and its discharge/via port both
 * exist and share the same id — i.e. the goods are discharged at the final destination, so the
 * ERS (expedited rail) leg is not applicable.
 *
 * `via_port` is nullable: LCL consolidation lanes (e.g. "Prime Freight Console" to a door
 * destination) carry no discharge/transshipment port. The previous inline check dereferenced
 * `via_port.id` unguarded, which threw for those rates. Because that throw happened inside the
 * un-isolated rate-mapping loop, a single such rate aborted the whole batch and made ALL rates for
 * the lane silently fail to load. Guarding both ids keeps the comparison safe.
 *
 * @param {Object} [rate={}] - a rate object with optional `location_to` and `via_port` relations
 * @returns {boolean}
 */
export const isSameDestinationDischarge = (rate = {}) =>
  rate?.location_to?.id != null &&
  rate?.via_port?.id != null &&
  rate.location_to.id === rate.via_port.id;

export default isSameDestinationDischarge;
